// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const sisustustyylit = [
  {
    id: "DatoCmsSisustustyylit-2017044-fi",
    title: "Tumma",
    bgcolor: {
      hex: "#001826",
      red: 0,
      green: 24,
      blue: 38,
    },
    seoMetaTags: {
      tags: [
        {
          tagName: "title",
          content: "Tumma sisustustyyli | Ester1",
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:title",
            content: "Tumma sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:title",
            content: "Tumma sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "description",
            content: "Tumma tyyli luo tunnelmallisen, rauhallisen ympäristön, joka tehostaa keskittymistä ja luovaa työskentelyä. Tumma työtila korostaa erityisesti urbaanin ja nuorekkaan yrityksen ilmettä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:description",
            content: "Tumma tyyli luo tunnelmallisen, rauhallisen ympäristön, joka tehostaa keskittymistä ja luovaa työskentelyä. Tumma työtila korostaa erityisesti urbaanin ja nuorekkaan yrityksen ilmettä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:description",
            content: "Tumma tyyli luo tunnelmallisen, rauhallisen ympäristön, joka tehostaa keskittymistä ja luovaa työskentelyä. Tumma työtila korostaa erityisesti urbaanin ja nuorekkaan yrityksen ilmettä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:card",
            content: "summary",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:modified_time",
            content: "2021-03-30T04:27:36Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:published_time",
            content: "2019-12-31T15:03:45Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:locale",
            content: "fi_FI",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:type",
            content: "article",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:site_name",
            content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:image",
            content: "/content-images/1615818793-hero-tumma-min.jpg",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:image",
            content: "/content-images/1615818793-hero-tumma-min.jpg",
          },
        },
      ],
    },
    kuva: asset("1615818793-hero-tumma-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    firstParagraphe: "Tumma tyyli luo tunnelmallisen, rauhallisen ympäristön, joka tehostaa keskittymistä ja luovaa työskentelyä. Tumma työtila korostaa erityisesti urbaanin ja nuorekkaan yrityksen ilmettä. Tumma on\nsamanaikaisesti sekä tasainen että kantaa-ottava, ja toimii rohkeampana pohjana erilaisille väriyhdistelmille ja brändi-ilmeille.",
    secondParagraphe: "Tumma tyyli syntyy syvistä sävymaailmoista ja mielenkiintoisista kontrasteista. Tumma ei tukeudu yksinkertaiseen mustaan, vaan rakentuu useista murretuista sävyistä, jotka yhdessä luovat eheän, tunnelmallisen kokonaisuuden.",
    secondImg: asset("1615818804-neukkari-tumma-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    catalogue: [
      {
        title: "Pinnat",
        titleShort: "Pinnat",
        img: asset("1615818401-blogi-tumma-pinnat.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Keittiö",
        titleShort: "Keittiö",
        img: asset("1615818410-blogi-tumma-keittio.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Kaluste-esimerkit",
        titleShort: "Kalusteita",
        img: asset("1615818414-blogi-tumma-kalusteet.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Efektiseinät",
        titleShort: "Seinät",
        img: asset("1617017350-blogi-tumma-efektit.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
    ],
    slug: "tumma",
  },
  {
    id: "DatoCmsSisustustyylit-2015638-fi",
    title: "Raikas",
    bgcolor: {
      hex: "#81adb3",
      red: 129,
      green: 173,
      blue: 179,
    },
    seoMetaTags: {
      tags: [
        {
          tagName: "title",
          content: "Raikas sisustustyyli | Ester1",
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:title",
            content: "Raikas sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:title",
            content: "Raikas sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "description",
            content: "Raikas tyyli on kevyt, ilmava ja anonyymi. Raikas luo helpon pohjan yrityksen kuin yrityksen brändi-ilmeelle, sallien tilaa erilaisille väriyhdistelmille ja tyyleille. Avaruus, valoisuus ja keveys korostuvat Raikkaan tyylin toimistossa.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:description",
            content: "Raikas tyyli on kevyt, ilmava ja anonyymi. Raikas luo helpon pohjan yrityksen kuin yrityksen brändi-ilmeelle, sallien tilaa erilaisille väriyhdistelmille ja tyyleille. Avaruus, valoisuus ja keveys korostuvat Raikkaan tyylin toimistossa.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:description",
            content: "Raikas tyyli on kevyt, ilmava ja anonyymi. Raikas luo helpon pohjan yrityksen kuin yrityksen brändi-ilmeelle, sallien tilaa erilaisille väriyhdistelmille ja tyyleille. Avaruus, valoisuus ja keveys korostuvat Raikkaan tyylin toimistossa.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:card",
            content: "summary",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:modified_time",
            content: "2021-03-30T04:27:54Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:published_time",
            content: "2019-12-30T19:00:33Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:locale",
            content: "fi_FI",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:type",
            content: "article",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:site_name",
            content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:image",
            content: "/content-images/1615818820-hero-raikas-min.jpg",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:image",
            content: "/content-images/1615818820-hero-raikas-min.jpg",
          },
        },
      ],
    },
    kuva: asset("1615818820-hero-raikas-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    firstParagraphe: "Raikas tyyli on kevyt, ilmava ja anonyymi. Raikas luo helpon pohjan yrityksen kuin yrityksen brändi-ilmeelle, sallien tilaa erilaisille väriyhdistelmille ja tyyleille. Avaruus, valoisuus ja keveys korostuvat Raikkaan tyylin toimistossa.",
    secondParagraphe: "Raikkaan tyylin luovat vaaleat, mutta pehmeät sävyt. Kylmä perusvalkoinen on korvattu hieman eri sävyihin taittavilla pinnoilla ja materiaaleilla, mikä luo tilaan elävyyden tuntua, pitäen samalla värimaailman kuitenkin erittäin hillittynä. Kolkon kokovalkoisen yleisilmeen sijaan Raikas luo tilaan utuisen pehmeän aamuisen tunnelman.",
    secondImg: asset("1615818825-neukkari-raikas-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    catalogue: [
      {
        title: "Pinnat",
        titleShort: "Pinnat",
        img: asset("1615811709-blogi-raikas-pinnat.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Keittiö",
        titleShort: "Keittiö",
        img: asset("1615812496-blogi-raikas-keittio.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Kaluste-esimerkit",
        titleShort: "Kalusteita",
        img: asset("1615810808-blogi-raikas-kalusteet.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Efektiseinät",
        titleShort: "Seinät",
        img: asset("1617017372-blogi-raikas-efektit.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
    ],
    slug: "raikas",
  },
  {
    id: "DatoCmsSisustustyylit-2017043-fi",
    title: "Lämmin",
    bgcolor: {
      hex: "#e0d1b6",
      red: 224,
      green: 209,
      blue: 182,
    },
    seoMetaTags: {
      tags: [
        {
          tagName: "title",
          content: "Lämmin sisustustyyli | Ester1",
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:title",
            content: "Lämmin sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:title",
            content: "Lämmin sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "description",
            content: "Lämpimän tyylin toimistossa korostuvat maanläheisyys ja kotoisa tunnelma. Lämmin luo toimistoon\nkodinomaista henkeä ja lisää viihtyisyyttä, korostaen yrityksen pehmeitä arvoja, mutkatonta kulttuuria, sekä helposti lähestytävyyttä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:description",
            content: "Lämpimän tyylin toimistossa korostuvat maanläheisyys ja kotoisa tunnelma. Lämmin luo toimistoon\nkodinomaista henkeä ja lisää viihtyisyyttä, korostaen yrityksen pehmeitä arvoja, mutkatonta kulttuuria, sekä helposti lähestytävyyttä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:description",
            content: "Lämpimän tyylin toimistossa korostuvat maanläheisyys ja kotoisa tunnelma. Lämmin luo toimistoon\nkodinomaista henkeä ja lisää viihtyisyyttä, korostaen yrityksen pehmeitä arvoja, mutkatonta kulttuuria, sekä helposti lähestytävyyttä.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:card",
            content: "summary",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:modified_time",
            content: "2021-03-30T04:28:58Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:published_time",
            content: "2019-12-31T15:03:42Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:locale",
            content: "fi_FI",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:type",
            content: "article",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:site_name",
            content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:image",
            content: "/content-images/1615818845-hero-lammin-min.jpg",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:image",
            content: "/content-images/1615818845-hero-lammin-min.jpg",
          },
        },
      ],
    },
    kuva: asset("1615818845-hero-lammin-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    firstParagraphe: "Lämpimän tyylin toimistossa korostuvat maanläheisyys ja kotoisa tunnelma. Lämmin luo toimistoon\nkodinomaista henkeä ja lisää viihtyisyyttä, korostaen yrityksen pehmeitä arvoja, mutkatonta kulttuuria, sekä helposti lähestytävyyttä.",
    secondParagraphe: "Lämpimän tyylin saavat aikaan lämmin värimaailma sekä eläväiset pinnat. Puupinnat korostavat kodinomaista tunnelmaa. Lämmin karttaa valkoisia pintoja, ja suosii syviä, murrettuja sävyjä, sekä eloisia\nväriyhdistelmiä. Lämmin tyyli luo tilaan syksyisen iltaruskon tunnelman.",
    secondImg: asset("1615818851-neukkari-lammin-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    catalogue: [
      {
        title: "Pinnat",
        titleShort: "Pinnat",
        img: asset("1615817300-blogi-lammin-pinnat.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Keittiö",
        titleShort: "Keittiö",
        img: asset("1615817304-blogi-lammin-keittio.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Kaluste-esimerkit",
        titleShort: "Kalusteita",
        img: asset("1615817312-blogi-lammin-kalusteet.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
      {
        title: "Efektiseinät",
        titleShort: "Seinät",
        img: asset("1617017394-blogi-lammin-efektit.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.126332,
        }),
      },
    ],
    slug: "lammin",
  },
  {
    id: "DatoCmsSisustustyylit-22427848-fi",
    title: "Uniikki",
    bgcolor: {
      hex: "#e0d1b6",
      red: 224,
      green: 209,
      blue: 182,
    },
    seoMetaTags: {
      tags: [
        {
          tagName: "title",
          content: "Uniikki sisustustyyli | Ester1",
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:title",
            content: "Uniikki sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:title",
            content: "Uniikki sisustustyyli",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "description",
            content: "Suunnittelijan avulla tehostatte tilankäyttöä, luotte brändinne mukaisen tyylin ja viimeistelette yksityiskohdat.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:description",
            content: "Suunnittelijan avulla tehostatte tilankäyttöä, luotte brändinne mukaisen tyylin ja viimeistelette yksityiskohdat.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:description",
            content: "Suunnittelijan avulla tehostatte tilankäyttöä, luotte brändinne mukaisen tyylin ja viimeistelette yksityiskohdat.",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:card",
            content: "summary",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:modified_time",
            content: "2021-03-30T04:29:11Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "article:published_time",
            content: "2021-02-26T08:05:03Z",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:locale",
            content: "fi_FI",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:type",
            content: "article",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:site_name",
            content: "Ester1 – toimistotila keskellä uutta Pasilaa ",
          },
        },
        {
          tagName: "meta",
          attributes: {
            property: "og:image",
            content: "/content-images/1616145056-hero-uniikki4-min.jpg",
          },
        },
        {
          tagName: "meta",
          attributes: {
            name: "twitter:image",
            content: "/content-images/1616145056-hero-uniikki4-min.jpg",
          },
        },
      ],
    },
    kuva: asset("1616145056-hero-uniikki4-min.jpg", {
      sizes: "(max-width: 1600px) 100vw, 1600px",
      aspectRatio: 1.777778,
    }),
    firstParagraphe: "Suunnittelijan avulla tehostatte tilankäyttöä, luotte brändinne mukaisen tyylin ja viimeistelette yksityiskohdat.",
    secondParagraphe: "Sisustussuunnittelijan toteuttama oma uniikki-tyyli on tilattavissa lisähintaan. Kysy tarkempi tarjous omasta tyylistäsi.",
    secondImg: null,
    catalogue: [
      {
        title: "Uniikki",
        titleShort: "Uniikki",
        img: asset("1616145315-uniikki-nelio2-min.jpg", {
          sizes: "(max-width: 740px) 100vw, 740px",
          aspectRatio: 1.005435,
        }),
      },
    ],
    slug: "uniikki",
  },
];

module.exports = { sisustustyylit };
